import { fetchCMSPage } from '../../common/api/cms';
import { NOT_FOUND } from '../status';

export const FETCH_PAGE = 'FETCH_PAGE';
export const FETCH_PAGE_SUCCESS = 'FETCH_PAGE_SUCCESS';
export const FETCH_PAGE_FAILURE = 'FETCH_PAGE_FAILURE';

export const fetchPage = pageName => async (dispatch) => {
  dispatch({
    type: FETCH_PAGE,
  });
  try {
    await dispatch({
      type: FETCH_PAGE_SUCCESS,
      [pageName]: await fetchCMSPage(pageName),
    });
  } catch (error) {
    if (error.statusCode === 400) {
      dispatch({
        type: NOT_FOUND,
        message: `Page ${pageName} could not be found`,
      });
    }
    dispatch({
      type: FETCH_PAGE_FAILURE,
      error,
    });
  }
};



// WEBPACK FOOTER //
// ./src/actions/cms/pages.js